/*
 * Module for the Service Purhase Payment Plan edit partial view
*/

rs.module("content/participant/member/servicepurchase/paymentplanedit",

    ["controls/components/event-banner", "common/select-helper"],

    function (eventBanner, selectHelper) {

        var _jsSelectors;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, originalBalance) {

            _jsSelectors = jsSelectors;

            var form = $.js(jsSelectors.form);

            // When the change parameters button is clicked reenable the form and hide the calculation section
            form.js(jsSelectors.changeButton, { required: false }).click(function () {

                _clearErrors();

                toggleInputs(true);
                form.js(jsSelectors.repaymentDetail).hide();

                form.js(jsSelectors.changeButton).hide();
                form.js(jsSelectors.calculateButton).show();
                form.js(jsSelectors.cancelButton).show();
                form.js(jsSelectors.formActions).hide();
                form.js(jsSelectors.saveButton).setDisabled();
            });

            // When calculate is clicked disable the form, send the request to load detail, and display the results
            form.js(jsSelectors.calculateButton, { required: false }).click(function () {

                // Validate form before performing calc
                var validator = form.closest("form").validate();
                var isValid = validator.form();

                if (isValid) {

                    // show loading spinner
                    form.js(jsSelectors.spinner).show();

                    // disable the form fields
                    toggleInputs(false);
                    form.js(jsSelectors.repaymentDetail).hide();

                    // make the call to load repayment detail
                    $.get(
                        backendUrls.loadRepaymentDetail,
                        {
                            loanInterestPercent: form.js(jsSelectors.loanInterestPercent).val(),
                            downPaymentAmount: form.js(jsSelectors.downPayment).val(),
                            repayBeginDate: form.js(jsSelectors.repayBeginDate).val(),
                            paymentFrequency: form.js(jsSelectors.paymentFrequency).val(),
                            numberOfPayments: form.js(jsSelectors.numberOfPayments).val(),
                            originalBalance: originalBalance
                        }
                    ).done(function (results) {

                        form.js(jsSelectors.repaymentDetail).html(results).show();

                        form.js(jsSelectors.changeButton).show();
                        form.js(jsSelectors.calculateButton).hide();
                        form.js(jsSelectors.cancelButton).hide();
                        form.js(jsSelectors.formActions).show();
                        form.js(jsSelectors.saveButton).setDisabled(false);

                    }).fail(function () {

                        // if there was an error, re enable form fields, and show corresponding buttons
                        toggleInputs(true);
                        form.js(jsSelectors.repaymentDetail).hide();

                        form.js(jsSelectors.changeButton).hide();
                        form.js(jsSelectors.calculateButton).show();
                        form.js(jsSelectors.cancelButton).show();
                        form.js(jsSelectors.formActions).hide();
                        form.js(jsSelectors.saveButton).setDisabled();

                    }).always(function () {

                        // hide loading spinner
                        form.js(jsSelectors.spinner).hide();
                    });
                }
            });

            //
            // Clear event banner and field errors
            //
            function _clearErrors() {

                // clear event banner
                eventBanner.removeAllMessages();
            }
        }

        //
        // Enable/disable form inputs
        //
        function toggleInputs(enable) {

            var form = $.js(_jsSelectors.form);

            form.js(_jsSelectors.downPayment).prop("disabled", !enable);
            form.js(_jsSelectors.numberOfPayments).prop("disabled", !enable);
            selectHelper.getHelper(form.js(_jsSelectors.paymentFrequency)).setDisabled(!enable);
            form.js(_jsSelectors.repayBeginDate).prop("disabled", !enable);
            form.js(_jsSelectors.loanInterestPercent).prop("disabled", !enable);

            // if we are disabling the fields, copy their values into hidden fields so they can still be posted
            if (!enable) {
                form.js(_jsSelectors.loanInterestPercentHiddenField).val(form.js(_jsSelectors.loanInterestPercent).val());
                form.js(_jsSelectors.downPaymentHiddenField).val(form.js(_jsSelectors.downPayment).val());
                form.js(_jsSelectors.repayBeginDateHiddenField).val(form.js(_jsSelectors.repayBeginDate).val());
                form.js(_jsSelectors.paymentFrequencyHiddenField).val(form.js(_jsSelectors.paymentFrequency).val());
                form.js(_jsSelectors.numberOfPaymentsHiddenField).val(form.js(_jsSelectors.numberOfPayments).val());
            }
        }

        // Exported public API
        var exports = {
            initialize,
            toggleInputs
        };

        return exports;
    }
);